import React from "react"
import { Redirect } from "react-router-dom"
import { LocationDetails } from "../types/Location"
import { PARENT_ID_MAPPING } from "./parentIdMapping"

export const providerFinderRootPath = "/providerfinder"

export const ProviderFinderParam = {
  Latitude: "lat",
  Longitude: "long",
  Country: "country",
  Search: "search",
  Page: "page",
  RadiusInKm: "radiusInKm",
  CarrotPartner: "carrotPartner",
  ProviderType: "providerType"
} as const

type ProviderFinderParams = {
  [ProviderFinderParam.Latitude]?: string
  [ProviderFinderParam.Longitude]?: string
  [ProviderFinderParam.Country]?: string
  [ProviderFinderParam.Search]: string
  [ProviderFinderParam.Page]: number
  [ProviderFinderParam.RadiusInKm]?: number
  [ProviderFinderParam.CarrotPartner]?: boolean
  [ProviderFinderParam.ProviderType]?: string | string[]
}

function buildProviderFinderSearchURL(params: ProviderFinderParams): URL {
  const newURL = new URL(`${providerFinderRootPath}/providers`, window.location.href)

  params.lat && newURL.searchParams.set(ProviderFinderParam.Latitude, params.lat)
  params.long && newURL.searchParams.set(ProviderFinderParam.Longitude, params.long)
  params.country && newURL.searchParams.set(ProviderFinderParam.Country, params.country)
  newURL.searchParams.set(ProviderFinderParam.Search, params.search)
  newURL.searchParams.set(ProviderFinderParam.Page, params.page?.toString())

  if (params.carrotPartner) {
    newURL.searchParams.set(ProviderFinderParam.CarrotPartner, params.carrotPartner.toString())
  }
  if (params.radiusInKm) {
    newURL.searchParams.set(ProviderFinderParam.RadiusInKm, params.radiusInKm.toFixed(1))
  }

  if (params.providerType && params.providerType.length) {
    const parsedProviderTypeString =
      typeof params.providerType === "string"
        ? params.providerType
        : params.providerType.filter((parentId) => Object.keys(PARENT_ID_MAPPING).indexOf(parentId) >= 0).join(",")
    newURL.searchParams.set(ProviderFinderParam.ProviderType, parsedProviderTypeString)
  }

  return newURL
}

type getProviderFinderSearchURLParams = {
  searchLocation: string
  locationDetails: LocationDetails
  radiusInKm?: number | string
  companyCountryCode: string
  carrotPartner?: boolean
  providerType?: string | string[]
}

export const getProviderFinderSearchURL = ({
  searchLocation,
  radiusInKm,
  locationDetails,
  carrotPartner,
  providerType
}: getProviderFinderSearchURLParams): URL => {
  const params: ProviderFinderParams = {
    [ProviderFinderParam.Search]: searchLocation,
    [ProviderFinderParam.Page]: 1,
    [ProviderFinderParam.Country]: locationDetails?.countryCode,
    [ProviderFinderParam.CarrotPartner]: carrotPartner,
    [ProviderFinderParam.ProviderType]: providerType,
    [ProviderFinderParam.RadiusInKm]: Number(radiusInKm)
  }
  params[ProviderFinderParam.Latitude] = locationDetails?.latitude && locationDetails.latitude.toString()
  params[ProviderFinderParam.Longitude] = locationDetails?.longitude && locationDetails.longitude.toString()

  return buildProviderFinderSearchURL(params)
}

export const RedirectToProviderFinderURL = ({ url }: { url: URL }): JSX.Element => {
  if (!url) {
    return null
  }

  return <Redirect push to={{ pathname: url.pathname, search: url.search }} />
}
